import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { Router } from '@angular/router';
import { NavigationService } from '../shared-services/navigation.service';

export class AbstractComponent {

    private HISTORIAL: 'historial';
    public HOME = '/home';
    protected historial: string[] = [];

    constructor(
        protected navigation: NavigationService,
        protected activatedRoute: ActivatedRoute,
        protected router: Router
        ) {

            this.router.events
            .filter(event => event instanceof NavigationEnd)
            .subscribe(({urlAfterRedirects}: NavigationEnd) => {
                if (urlAfterRedirects === '/login') {
                    this.historial = [];
                    localStorage.removeItem(this.HISTORIAL);
                } else {
                    this.setPaginaAnterior(urlAfterRedirects);
                }
            });
     }

     setPaginaAnterior(url: string) {
        const historialGuardado = localStorage.getItem(this.HISTORIAL);
        let ultimaURL: string;
        if (historialGuardado) {
            this.historial = JSON.parse(historialGuardado);
            ultimaURL = this.historial.pop();
        }

        if (ultimaURL === url || ultimaURL === ''  || ultimaURL === undefined) {
            this.historial.push(url);
        } else {
            const anteriorUltima: string = this.historial.pop();
            if (anteriorUltima === url) {
                this.historial.push(url);
            } else {
                this.historial.push(anteriorUltima);
                this.historial.push(ultimaURL);
                this.historial.push(url);
            }
        }

        localStorage.setItem(this.HISTORIAL, JSON.stringify(this.historial));
     }

     getPaginaAnterior() {

        const historialGuardado = localStorage.getItem(this.HISTORIAL);

        if (historialGuardado) {
            this.historial = JSON.parse(historialGuardado);
            if (this.historial.length !== 0) {
                this.historial.pop(); // Quito la pagina actual
                const retorno = this.historial.pop(); // Obtengo la pagina anterior
                localStorage.setItem(this.HISTORIAL, JSON.stringify(this.historial));
                return retorno == null ? this.HOME : retorno;
            } else {
                return this.HOME;
            }
        } else {
            return this.HOME;
        }
     }

     back() {
         this.navigation.back( this.getPaginaAnterior() );
     }

     detallesDeCliente(urlActual: string, ultimaURL: string) {
        const ultimaParseada: string[] = ultimaURL.split('/');
        const ultimaLen = ultimaParseada.length;

        const actualParseada: string[] = urlActual.split('/');
        const actualLen = actualParseada.length;

        return ultimaParseada[ultimaLen] === actualParseada[actualLen]
                && ultimaParseada[ultimaLen] === 'detalles';
     }

}




// WEBPACK FOOTER //
// ./src/app/core/abstract-component.ts